module.exports = __webpack_public_path__ + "static/media/icn_salaried.99c93f44.svg";